import { render, staticRenderFns } from "./ClearFilterBtn.vue?vue&type=template&id=002347a4&scoped=true&"
import script from "./ClearFilterBtn.vue?vue&type=script&lang=js&"
export * from "./ClearFilterBtn.vue?vue&type=script&lang=js&"
import style0 from "./ClearFilterBtn.vue?vue&type=style&index=0&id=002347a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002347a4",
  null
  
)

export default component.exports